import Page from "../../../modules/Core/Components/Page";
import templateDefault from "../../templates/default/pages/our_story";

export default class CoreValues extends Page {
  template = templateDefault;

  onAuth() {
    this.refresh();
  }

  onLoad(data) {
    super.onLoad(data);
    this.getApp().updateWindowTitle(
      `Our Story | ${this.trans("window-title")}`
    );
    this.scrollToTop();
  }
}
